import { Controller } from '@hotwired/stimulus'
import { post } from '../lib/request'

const URL = '/internal/image_sizes'
const TAGS_URL = '/internal/image_tags'

export default class extends Controller {
  connect = () => {
    this.element.addEventListener('change', this.getImage)
  }

  getImage = (event) => {
    const file = event.target.files[0]
    this.setAnimation()
    this.showAnimation()

    if (file.type && file.type.startsWith('image/')) {
      const reader = new FileReader()

      reader.onload = (event) => {
        const img = new Image()

        img.onload = () => {
          const type = file.type.split('/').pop()

          const data = {
            width: img.naturalWidth,
            height: img.naturalHeight,
            type: type,
          }
          const params = new URLSearchParams(data).toString()
          const url = `${URL}?${params}`

          post(url, { responseKind: 'turbo-stream' })

          const formData = new FormData()
          formData.append('file', file)

          post(TAGS_URL, {
            body: formData,
            responseKind: 'turbo-stream',
          })
        }
        img.src = event.target.result
        const container = document.getElementById('imageContainer')
        const existingImage = container.querySelector('img')

        if (existingImage) existingImage.remove()

        container.appendChild(img)
      }

      reader.readAsDataURL(file)
    }
    else {
      console.log('Selected file is not an image.')
    }
  }

  showAnimation = () => {
    let logo = document.getElementById('animated_logo')

    if (!logo) {
      const tags = document.getElementById('tags')
      logo = this.animation.cloneNode(true)
      tags.innerHTML = ''
      tags.appendChild(logo)
    }

    logo.style.display = 'flex'
  }

  setAnimation = () => {
    if (this.animation) return

    const logo = document.getElementById('animated_logo')
    this.animation = logo.cloneNode(true)
  }
}
